import { OnInit } from '@angular/core';
import { UiService } from '../ui/ui.service';
var BigBorderComponent = /** @class */ (function () {
    function BigBorderComponent(ui) {
        var _this = this;
        this.ui = ui;
        ui.accentuated$.subscribe(function (b) { return _this.accentuated = b; });
        ui.whitened$.subscribe(function (b) { return _this.whiteBordered = b; });
    }
    BigBorderComponent.prototype.ngOnInit = function () {
    };
    return BigBorderComponent;
}());
export { BigBorderComponent };
//# sourceMappingURL=big-border.component.js.map